import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import offline from '../../assets/sinred.png'
import ProgressBar from 'react-bootstrap/ProgressBar';
const server = process.env.REACT_APP_SERVER;

function ItemCardSucursal(props) {
    const { sucursal, actualizar, vista } = props;
    const [informacion, setInformacion] = useState({});
    const [sumatoria, setSumatoria] = useState([]);
    const [procesos, setProcesos] = useState([]);
    const [error, setError] = useState({});
    function sumarTotal(lista, tipo) {
        var listaf = lista.filter((item) => item.Tipo == 'Pollo')
        var datos = []
        if (tipo == 1) {
            datos = listaf.map((item) => item.Cant1)
        } else if (tipo == 2) {
            datos = listaf.map((item) => item.Cant2)
        } else {
            datos = listaf.map((item) => item.Cant4)
        }
        var total = datos.reduce((a, b) => parseInt(a) + parseInt(b), 0);
        return total;
    }
    function getCantidades(info) {
        if (info.Tipo == 'Pollo') {
            return info.Cant1 + ' A + ' + info.Cant2 + ' P'
        } else if (info.Tipo == 'Pipoca') {
            return info.Cant4 + ' C'
        } else {
            return info.Cant1+' PAPA'
        }
    }
    function getInformacionProceso() {
        fetch(`${server}/reporte/getInformacionProceso`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...sucursal
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.ok) {
                    if (sucursal.ID_SUCURSAL == 5) { console.log(data.ok); }
                    setInformacion(data.ok)
                    var arreglo = data.ok.procesos;
                    var aux = []
                    aux.push(sumarTotal(arreglo, 1))
                    aux.push(sumarTotal(arreglo, 2))
                    aux.push(sumarTotal(arreglo, 4))
                    setProcesos(data.ok.procesos);
                    setSumatoria(aux);
                } else {
                    setError({ "error": "Error Sucursal " + sucursal.SUCURSAL })
                }
            })
            .catch(error => MsgUtils.msgError(error));
    }
    useEffect(() => {
        getInformacionProceso()
    }, [actualizar])
    return (
        <>
            {vista == 'C' && <div className='col ' >
                <div className='card bg-dark' style={{ minHeight: '220px' }}>
                    <div className='card-header text-light text-center'>
                        {sucursal.SUCURSAL}
                    </div>
                    <div className='card-body'>
                        {error.error == undefined && <div className='table-responsive'>
                            <table className="table table-dark">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">ALAS</th>
                                        <th scope="col">PIERNAS</th>
                                        <th scope="col">PIPOCAS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">EXPO</th>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo1 : informacion.ExpoReal1}</td>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo2 : informacion.ExpoReal2}</td>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo4 : informacion.ExpoReal4}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">+PROD</th>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo1 + sumatoria[0] : informacion.ExpoReal1 + sumatoria[0]}</td>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo2 + sumatoria[1] : informacion.ExpoReal2 + sumatoria[1]}</td>
                                        <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo4 + sumatoria[2] : informacion.ExpoReal4 + sumatoria[2]}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>}
                        {error.error !== undefined &&
                            <div className='container-fluid text-center'>
                                <img src={offline} style={{}}></img>
                            </div>
                        }
                    </div>
                </div>
            </div>}
            {vista == 'L' &&
                <div >
                    {error.error == undefined &&
                        <div>
                            <div className='container-fluid overflow-auto' style={{height:'120px'}}>
                                <div className='row row-cols-2 g-1 gx-1'>
                                    {procesos.map((item, index) => {
                                        return (
                                            <div className='col border border-light' key={index}>
                                                <div className='row row-cols-2 g-1 p-1'>
                                                    <div className='col-4'>
                                                        <div className='text-center text-light lh-1' style={{ fontSize: '9px' }}>Freidora</div>
                                                        <div className='text-light text-center lh-1'>{item.Freidora}</div>
                                                        <div className='text-light text-center lh-1' style={{ fontSize: '9px' }}>{item.Tipo}</div>
                                                    </div>
                                                    <div className='col-5 text-light my-auto text-center' style={{fontSize:'12px'}}>
                                                        {getCantidades(item)}
                                                    </div>
                                                    <div className='col-3 text-light my-auto'>
                                                        <div className='text-light text-center lh-1'>{parseInt(item.TiempoRestante)}</div>
                                                        <div className='text-light text-center lh-1' style={{ fontSize: '8px' }}>tiempo</div>
                                                    </div>
                                                </div>
                                                <ProgressBar now={parseInt(item.TiempoRestante)} 
                                                    max={40}
                                                    label={`<${parseInt(item.TiempoRestante)}`} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='table-responsive'>
                                <table className="table table-dark table-sm table-bordered border-light">
                                    <thead>
                                        <tr>
                                            <th scope="col"></th>
                                            <th scope="col">ALAS</th>
                                            <th scope="col">PIERNA</th>
                                            <th scope="col">PIPOC</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        <tr>
                                            <th scope="row">EXPO</th>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo1 : informacion.ExpoReal1}</td>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo2 : informacion.ExpoReal2}</td>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo4 : informacion.ExpoReal4}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">+PROD</th>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo1 + sumatoria[0] : informacion.ExpoReal1 + sumatoria[0]}</td>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo2 + sumatoria[1] : informacion.ExpoReal2 + sumatoria[1]}</td>
                                            <td>{(sucursal.CAMPO == null || sucursal.CAMPO == undefined) ? informacion.Expo4 + sumatoria[2] : informacion.ExpoReal4 + sumatoria[2]}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    {error.error !== undefined &&
                        <div className='container-fluid text-center'>
                            <img src={offline} style={{}}></img>
                        </div>
                    }
                </div>}
        </>
    )
}

export default ItemCardSucursal